module.exports = __webpack_public_path__ + "static/customer2-f8bbae95560049488cd812299d993941.jpg";